import React, { useState, useRef, useEffect } from 'react';
import emojiList from './fullEmojiList';
import './emojiPicker.css';

const CATEGORIES = [
  { code: 'p', name: 'People', icon: '😊' },
  { code: 'n', name: 'Nature', icon: '🌿' },
  { code: 'd', name: 'Food', icon: '🍕' },
  { code: 's', name: 'Symbols', icon: '💠' },
  { code: 'a', name: 'Activity', icon: '⚽' },
  { code: 't', name: 'Travel', icon: '✈️' },
  { code: 'o', name: 'Objects', icon: '💡' },
  { code: 'f', name: 'Flags', icon: '🏳️' },
];

const EmojiPicker = ({ onEmojiSelect, onClose }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('p');
  const pickerRef = useRef(null);

  const filteredEmojis = emojiList.filter(emoji => {
    const matchesSearch = searchTerm === '' || 
      emoji.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
      (emoji.shortname && emoji.shortname.toLowerCase().includes(searchTerm.toLowerCase()));
    
    const matchesCategory = searchTerm === '' ? emoji.category === selectedCategory : true;
    
    return matchesSearch && matchesCategory;
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (pickerRef.current && !pickerRef.current.contains(event.target)) {
        onClose();
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [onClose]);

  return (
    <div className="custom-emoji-picker" ref={pickerRef}>
      <div className="emoji-picker-header">
        <input
          type="text"
          placeholder="Search emojis..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="emoji-search"
        />
      </div>
      {searchTerm === '' && (
        <div className="emoji-categories">
          {CATEGORIES.map((category) => (
            <button
              key={category.code}
              className={`emoji-category-btn ${selectedCategory === category.code ? 'active' : ''}`}
              onClick={() => setSelectedCategory(category.code)}
              title={category.name}
            >
              {category.icon}
            </button>
          ))}
        </div>
      )}
      <div className="emoji-picker-body">
        {filteredEmojis.length > 0 ? (
          filteredEmojis.map((emoji) => (
            <div
              key={emoji.name}
              className="emoji-item"
              onClick={() => onEmojiSelect(emoji)}
              title={`${emoji.name} ${emoji.shortname}`}
            >
              {emoji.code_decimal ? (
                <div dangerouslySetInnerHTML={{ __html: emoji.code_decimal }} />
              ) : (
                <span>
                  {String.fromCodePoint(parseInt(emoji.unicode, 16))}
                </span>
              )}
            </div>
          ))
        ) : (
          <div className="emoji-no-results">No emojis found</div>
        )}
      </div>
    </div>
  );
};

export default EmojiPicker;

